import { z } from "zod";

export const FEEDBACK_SOURCES = ["Officevibe", "Custom", "Onboarding", "Smart", "NonSurvey"] as const;
export const FeedbackSourceSchema = z.enum(FEEDBACK_SOURCES);
export type FeedbackSource = z.infer<typeof FeedbackSourceSchema>;

export const FeedbackDateDisplayModeSchema = z.enum(["week", "absolute"]);
export type FeedbackDateDisplayMode = z.infer<typeof FeedbackDateDisplayModeSchema>;

export const FeedbackSentimentSchema = z.enum(["Positive", "Constructive", "Neutral"]);
export type FeedbackSentiment = z.infer<typeof FeedbackSentimentSchema>;

export const FeedbackMetricSchema = z.enum(["recognition", "feedback", "relationshipWithPeers", "relationshipWithManager", "satisfaction", "alignment", "happiness", "wellness", "personalGrowth", "ambassadorship"]);
export type FeedbackMetric = z.infer<typeof FeedbackMetricSchema>;

export const FEEDBACK_METRIC_IDS = ["MG-1", "MG-2", "MG-3", "MG-4", "MG-5", "MG-6", "MG-7", "MG-8", "MG-9", "MG-10"] as const;
export type FeedbackMetricId = (typeof FEEDBACK_METRIC_IDS)[number];

export const FeedbackToMonitorClassificationSchema = z.object({
    category: z.string(),
    reason: z.string().optional()
});
export type FeedbackToMonitorClassification = z.infer<typeof FeedbackToMonitorClassificationSchema>;
